import React from 'react'

const IconForwardArrow: React.FunctionComponent = () => {
  return (
    <>
      <svg viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path transform="scale(1)" d="M17.1527 4.50343C21.9357 7.77078 26.1086 11.8516 29.4818 16.5604C29.6427 16.8204 29.9805 17.5782 29.8707 17.8405C28.1866 19.5628 25.8437 19.5453 23.751 20.4031C21.6582 21.2608 19.7874 23.5214 17.2356 24.187C16.767 24.2272 16.2956 24.1533 15.8617 23.9717C15.4279 23.7901 15.0444 23.5062 14.7441 23.1442C14.4162 23.0069 13.3961 21.5782 14.2576 21.3609C16.7247 20.6213 18.2426 18.5598 20.5763 17.4946C22.9099 16.4295 24.9105 16.8045 26.4604 15.2187L26.8165 16.485C24.1196 12.657 20.786 9.31992 16.9607 6.6191C16.3378 6.35837 15.0928 5.37491 15.2582 4.5195C15.4236 3.66408 16.7265 4.32504 17.1527 4.50343Z" fill="#111111"></path>
          <path transform="scale(1)" d="M28.5398 17.7074C24.8392 15.8064 20.7616 14.7537 16.6032 14.6259C12.4448 14.4981 8.31019 15.2983 4.49983 16.9686C2.91559 17.808 0.0199132 14.7852 1.63694 13.9595C9.82346 9.68065 19.9718 11.116 28.0991 14.7104C28.6118 14.8679 29.0779 15.1491 29.4563 15.5292C29.8347 15.9093 30.1138 16.3767 30.2689 16.8901C30.3467 17.8088 29.3594 18.0505 28.6382 17.7486" fill="#111111"></path>
        </g>
        <defs>
          <clipPath>
            <rect width="27.7564" height="18.445" fill="white" transform="matrix(-0.922452 -0.386112 -0.386112 0.922452 32.7266 11.0215)"></rect>
          </clipPath>
        </defs>
      </svg>
    </>
  )
}

export default IconForwardArrow;
